import React, { Component } from 'react'
import { BrowserRouter as Router, Route, Redirect, Switch} from 'react-router-dom'
import { Provider } from 'react-redux'

import 'bootstrap/dist/css/bootstrap.css'
import 'App.css'

import createStore from 'ducks/create'
import ErrorHandler from 'ErrorHandler'
import FindPutter from 'containers/FindPutter'
import Customize from 'containers/Customize'
import DeepLink from 'containers/DeepLink'
import { createConfirmNavigation } from 'containers/NavWarning'
import {AnalyticsPageTracker} from './util/analytics';

const store = createStore();

const TrackedCustomize = AnalyticsPageTracker(Customize)
const TrackedDeepLink = AnalyticsPageTracker(DeepLink)

export class App extends Component {
  constructor() {
    super()
    this.confirmNavigation = createConfirmNavigation(store).bind(this);
  }

  render() {
    return (
      <Provider store={store}>
        <Router basename={process.env.PUBLIC_URL + "/"} getUserConfirmation={this.confirmNavigation} >
          <div className="app customizer container">
            <Switch>
              <Route exact path="/">
                <Redirect to="/findputter" />
              </Route>
              <Route path="/findputter" component={AnalyticsPageTracker(FindPutter)} />
              <Route path="/instance/:instanceId" component={TrackedDeepLink} />
              <Route path="/saved/:savedInstanceId" component={TrackedDeepLink} />
              <Route path="/order/:orderItemId" component={TrackedDeepLink} />
              <Route path="/customize/:id/:page/save" render={(props)=> <TrackedCustomize autoAddToSaved={true} {...props} />} />
              <Route path="/customize/:id/buy" render={(props)=> <TrackedCustomize buyAPutter={true} {...props} />} />
              <Route path="/customize/:id" component={TrackedCustomize} />
              <Redirect to="/findputter" />
            </Switch>

          </div>
        </Router>
      </Provider>
    )
  }
}

export default ErrorHandler(App);